import { useSelector } from 'react-redux';
import type { CSSProperties, VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import FileViewer from '../../../shared/revisions/FileViewer';
import type { LicensingIssue } from '../../../../../shared/issuesV2';

type Props = {
  /**
   * optional min height of the file content
   */
  minHeight?: CSSProperties['minHeight'],
};

/**
 * LicensingIssueDetailsFileMatches displays a list of file matches
 * based on the Issue.source where this issue was found.
 *
 * Using the FileViewer generic, it displays info about this
 * particular license, as well as displaying the list of matched
 * files in a Select dropdown, as well as displaying the matched
 * source code in a CodeMirror window.
 */
const LicensingIssueDetailsFileMatches: VoidFunctionComponent<Props> = ({
  minHeight,
}) => {
  const issueDetails = useSelector(IssuesV2Store.selectors.getIssueDetails) as LicensingIssue | null;
  const isUnlicensed = useSelector(IssuesV2Store.selectors.getIsIssueDetailsUnlicensed);

  if (!issueDetails || !issueDetails?.source?.id || isUnlicensed) {
    return null;
  }

  return (
    <FileViewer
      revisionId={issueDetails?.source?.id}
      licenseId={issueDetails?.license as string}
      minHeight={minHeight}
    />
  );
};

export default LicensingIssueDetailsFileMatches;
